module.exports = __webpack_public_path__ + "static/img/emotions1_09.640946a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_09.png
// module id = IqN8
// module chunks = 0